import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import Button from "../../../shared/components/atoms/button/button";
import HeartRating from '../../../shared/components/atoms/heart-rating/heart-rating';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import './card-product.scss';

const CardProduct = ({ product, productRating, setActiveShoppingModal }) => {

    const { homeLink } = useHomeLinkMode();

    return (
        <div className="f-a-card-product">
            {product &&
                <div className="f-a-single-card-container">

                    <a className="f-a-card-product-container">
                        <div className="f-a-card-product-content">
                            <div className="f-a-card-product-image-container" onClick={() => { location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "productos/") + product.categoria[0].idCategoria + product.slug }}>
                                <GatsbyImage
                                    image={product.imagenProducto[0].gatsbyImageData}
                                    alt="imagen producto"
                                    className="f-a-card-product-image"
                                />
                            </div>

                            <div className="f-a-card-product-info" onClick={() => { location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "productos/") + product.categoria[0].idCategoria + product.slug }}>
                                <div className="f-a-card-product-rate">
                                    <HeartRating
                                        rate={productRating ? productRating.averageRate : (product.ratingValue ? product.ratingValue : 0)}
                                        ratingsNumber={productRating ? productRating.countRate : (product.reviewCount ? product.reviewCount : 0)}
                                        readOnly={true}
                                    />
                                </div>
                                <h3 className="f-a-card-product-name">{product.nombreProducto}</h3>
                                <p className="f-a-card-product-description">{product.descripcionCorta && product.descripcionCorta.descripcionCorta}</p>
                            </div>

                            <div className="f-a-card-product-content__button">
                                <Button className="f-a-button__primary-purple f-a-button__small"
                                    copy={'Comprar ahora'}
                                    onclick={() => setActiveShoppingModal(true)} />
                            </div>
                        </div>
                    </a>
                </div>
            }
        </div>
    )

}

export default CardProduct